'use client'

import { twMerge } from '@/lib/classname/twMerge'
import { Icon } from '@/ui/icons/icon/Icon'
import { Column as AriaColumn, composeRenderProps, type ColumnProps } from 'react-aria-components'
import { useTable } from '../TableContext'

// No custom aria-label for sortable columns: react-aria's useTableColumnHeader ignores it and
// generates its own localized "sortable column" description via aria-describedby
type TableColumnProps = ColumnProps

export function Column({ className, ...props }: TableColumnProps) {
  const { variant } = useTable()

  return (
    <AriaColumn
      {...props}
      className="border-b-px border-r-px border-brand-2-200 p-1 text-left font-normal last:border-r-0"
    >
      {composeRenderProps(props.children, (children, { allowsSorting }) => (
        <div
          className={twMerge(
            'flex items-center justify-between',
            allowsSorting && 'cursor-pointer',
          )}
        >
          <div className={twMerge('line-clamp-2 w-full', !allowsSorting && className)}>
            {children}
          </div>
          {allowsSorting && (
            <span className="sort-indicator hidden text-brand-2-900 desktop:block">
              <Icon.ChevronsUpDown
                size="sm"
                className={variant === 'light' ? 'text-brand-2-900' : 'text-white'}
              />
            </span>
          )}
        </div>
      ))}
    </AriaColumn>
  )
}
